import { useRef } from 'react';

/**
 * The last non-null value this hook has seen.
 *
 * A side panel that is closing still needs its record for the slide-out after
 * the host has already cleared the selection; holding the last record here
 * lets the host keep the panel mounted and simply drive `visible`, without
 * knowing when the animation ends.
 */
export function useLastDefined<T>(value: T | null | undefined): T | undefined {
  const last = useRef<T | undefined>(undefined);
  if (value != null) {
    last.current = value;
  }
  return last.current;
}
